import React from "react";
import { css } from "emotion";

const Button = ({
  size = "medium",
  color = "primary",
  type = "primary",
  aria = "",
  tabIndex = "0",
  width = "auto",
  ariaHidden,
  children
}) => {
  const globals = {
    fontSize: 16,
    fontWeight: 600,
    width,
    cursor: "pointer"
  };

  const sizes = {
    large: {
      padding: "11px 24px",
      "@media(max-width: 600px)": {
        fontSize: 14,
        padding: "0px 24px"
      }
    },
    medium: {
      padding: "9\0px 24px",
      "@media(max-width: 600px)": {
        fontSize: 14,
        padding: "0px 24px"
      }
    },
    small: {
      fontSize: 14,
      padding: "0px 24px"
    }
  };

  const colours = {
    primary: {
      normal: "#2074d9",
      hover: "#0E4E9B",
      textColor: "#fff"
    },
    secondary: {
      normal: "#9752AB",
      hover: "#814592",
      textColor: "#fff"
    },
    tertiary: {
      normal: "#148663",
      hover: "#096C4E",
      textColor: "#fff"
    },
    humanitix: {
      normal: "#1AB97E",
      hover: "#1EC587",
      textColor: "#323232"
    }
  };

  const style = {
    primary: {
      border: "none",
      borderRadius: 4,
      backgroundColor: colours[color]["normal"],
      color: colours[color]["textColor"],
      "&:hover": {
        backgroundColor: colours[color]["hover"]
      }
    },
    secondary: {
      border: `1px solid ${colours[color]["normal"]}`,
      borderRadius: 4,
      backgroundColor: "transparent",
      color: colours[color]["normal"],
      "&:hover": {
        backgroundColor: colours[color]["normal"],
        color: colours[color]["textColor"]
      }
    }
  };

  return (
    <button
      className={css({ ...globals, ...sizes[size], ...style[type] })}
      aria-label={aria}
      aria-hidden={ariaHidden}
      tabIndex={ariaHidden ? -1 : tabIndex}
    >
      {children}
    </button>
  );
};

export default Button;
